/**
 * Events load more
 * ======================================
 */

 const ELEMENTS = ".events__item.hide";
 const BUTTON = ".js-EventsLoadMore";

 class EventsLoadMore {
   constructor() {
     this.elements = document.querySelectorAll(ELEMENTS);
     this.button = document.querySelector(BUTTON);

     if (!this.button) {
       return false;
     }

     this.button.addEventListener("click", this.show);
   }

   show = (e) => {
    const el = e.currentTarget;

    document.querySelector('.events').classList.remove('events--preview-visible')

    el.classList.add('hide')

    this.elements.forEach((el) => {
      el.classList.remove('hide')
    });

     e.preventDefault();
   };
 }

 new EventsLoadMore();
